var EVENT_BINDING_DATASET_PURPOSE = 'eventBindings';
var EVENT_BINDING_DATASET_NAME = 'Event Bindings';
var EVENT_BINDING_ROLE = 'trip-reset';
var EVENT_BINDING_COLUMN_NAME = 'Event Point';

function normalizeRid(rid) {
  if (!rid) return null;
  var rawRid = String(rid);
  if (!rawRid) return null;
  return rawRid.charAt(0) === '#' ? rawRid : ('#' + rawRid);
}

function getContainsEdges(record) {
  return record && Array.isArray(record.out_Contains) ? record.out_Contains : [];
}

function getReportAttachmentEdgeList(record) {
  if (record && Array.isArray(record.out_ReportAttachment)) {
    return record.out_ReportAttachment;
  }

  var explicitEdges = record && Array.isArray(record.out_IncludesRecord)
    ? record.out_IncludesRecord
    : [];
  var legacyEdges = getContainsEdges(record).filter(function (edge) {
    var node = getContainedNode(edge);
    if (!node || isEventBindingDataset(node)) return false;
    if (node['@class'] === 'Element') return false;
    if (isDatasetRecord(node)) return false;
    return true;
  });

  return explicitEdges.concat(legacyEdges);
}

function getContainedNode(edge) {
  return edge && edge.in && typeof edge.in === 'object' ? edge.in : null;
}

function isDatasetRecord(record) {
  if (!record || typeof record !== 'object') return false;
  return record['@class'] === 'Dataset' || Array.isArray(record.out_Column);
}

function isReservedEventBindingDataset(record) {
  return isDatasetRecord(record) && record.name === EVENT_BINDING_DATASET_NAME;
}

function isMarkedEventBindingDataset(record) {
  if (!isDatasetRecord(record)) return false;
  if (record.purpose === EVENT_BINDING_DATASET_PURPOSE) return true;
  if (record.isSystem === true) return true;
  return isReservedEventBindingDataset(record) && record.visible === 'false';
}

function isLegacyEventBindingDataset(record) {
  if (!isReservedEventBindingDataset(record)) return false;
  var columns = Array.isArray(record.out_Column) ? record.out_Column : [];
  return columns.length === 0;
}

function isEventBindingDataset(record) {
  return isMarkedEventBindingDataset(record) || isLegacyEventBindingDataset(record);
}

function getEventBindingDataset(reportRecord) {
  var edges = getContainsEdges(reportRecord);
  for (var i = 0; i < edges.length; i += 1) {
    var node = getContainedNode(edges[i]);
    if (isMarkedEventBindingDataset(node)) {
      return node;
    }
  }
  for (var j = 0; j < edges.length; j += 1) {
    var fallbackNode = getContainedNode(edges[j]);
    var fallbackColumns = fallbackNode && Array.isArray(fallbackNode.out_Column) ? fallbackNode.out_Column : [];
    if (isReservedEventBindingDataset(fallbackNode) && fallbackColumns.length > 0) {
      return fallbackNode;
    }
  }
  for (var k = 0; k < edges.length; k += 1) {
    var legacyNode = getContainedNode(edges[k]);
    if (isLegacyEventBindingDataset(legacyNode)) {
      return legacyNode;
    }
  }
  return null;
}

function getReportContentContainsEdges(reportRecord) {
  return getContainsEdges(reportRecord).filter(function (edge) {
    return !isEventBindingDataset(getContainedNode(edge));
  });
}

function getReportAttachmentEdges(reportRecord) {
  var seen = new Set();
  return getReportAttachmentEdgeList(reportRecord).filter(function (edge) {
    var edgeRid = normalizeRid(edge && edge['@rid']);
    var nodeRid = normalizeRid(edge && edge.in && edge.in['@rid']);
    var identity = edgeRid || ('node:' + nodeRid);
    if (!identity || seen.has(identity)) return false;
    seen.add(identity);
    return true;
  });
}

function getPrimaryReportElement(reportRecord) {
  var contentEdges = getReportContentContainsEdges(reportRecord);
  for (var i = 0; i < contentEdges.length; i += 1) {
    var node = getContainedNode(contentEdges[i]);
    if (node && node['@class'] === 'Element') {
      return node;
    }
  }
  for (var j = 0; j < contentEdges.length; j += 1) {
    var fallbackNode = getContainedNode(contentEdges[j]);
    if (fallbackNode && !isDatasetRecord(fallbackNode)) {
      return fallbackNode;
    }
  }
  return null;
}

function buildEventBindingCells(reportRecord) {
  var datasetRecord = getEventBindingDataset(reportRecord);
  var columnRecords = datasetRecord && Array.isArray(datasetRecord.out_Column) ? datasetRecord.out_Column : [];

  return columnRecords
    .filter(function (columnRecord) {
      return columnRecord && columnRecord['@rid'] && columnRecord.in && columnRecord.in['@rid'];
    })
    .sort(function (a, b) {
      return Number(a.index || 0) - Number(b.index || 0);
    })
    .map(function (columnRecord) {
      var pointRecord = columnRecord.in;
      return {
        role: EVENT_BINDING_ROLE,
        columnId: Number(columnRecord.index),
        columnName: columnRecord.name || EVENT_BINDING_COLUMN_NAME,
        datasetName: datasetRecord && datasetRecord.name ? datasetRecord.name : EVENT_BINDING_DATASET_NAME,
        datasetRid: normalizeRid(datasetRecord && datasetRecord['@rid']),
        columnRid: normalizeRid(columnRecord['@rid']),
        pointRid: normalizeRid(pointRecord && pointRecord['@rid']),
        pointName: pointRecord && pointRecord.name ? pointRecord.name : null,
        bound: true,
        columnRecord: columnRecord,
        datasetRecord: datasetRecord || null
      };
    });
}

function buildEventConfigBindings(reportRecord) {
  return buildEventBindingCells(reportRecord)
    .filter(function (cell) {
      return cell.bound && cell.columnRid && cell.pointRid;
    })
    .map(function (cell) {
      return {
        columnRid: cell.columnRid,
        pointRid: cell.pointRid,
        datasetRid: cell.datasetRid,
        columnId: cell.columnId,
        role: EVENT_BINDING_ROLE,
        label: cell.datasetName + ' / ' + (cell.pointName || cell.columnName || EVENT_BINDING_COLUMN_NAME)
      };
    });
}

function getNextEventBindingIndex(reportRecord) {
  var cells = buildEventBindingCells(reportRecord);
  if (!cells.length) return 0;
  return cells.reduce(function (maxIndex, cell) {
    return Math.max(maxIndex, Number(cell.columnId) || 0);
  }, -1) + 1;
}

module.exports = {
  EVENT_BINDING_DATASET_PURPOSE: EVENT_BINDING_DATASET_PURPOSE,
  EVENT_BINDING_DATASET_NAME: EVENT_BINDING_DATASET_NAME,
  EVENT_BINDING_ROLE: EVENT_BINDING_ROLE,
  EVENT_BINDING_COLUMN_NAME: EVENT_BINDING_COLUMN_NAME,
  normalizeRid: normalizeRid,
  isEventBindingDataset: isEventBindingDataset,
  getEventBindingDataset: getEventBindingDataset,
  getReportContentContainsEdges: getReportContentContainsEdges,
  getReportAttachmentEdges: getReportAttachmentEdges,
  getPrimaryReportElement: getPrimaryReportElement,
  buildEventBindingCells: buildEventBindingCells,
  buildEventConfigBindings: buildEventConfigBindings,
  getNextEventBindingIndex: getNextEventBindingIndex
};
